


























































import ListagemDeCashback from '@/components/cliente/ListagemDeCashback.vue';
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue';
import { Cliente } from '@/models';
import { aplicarMascaraParaCpfOculto, formatarCnpjOuCpf } from '@/shareds/formatadores';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { FindClienteUseCase } from '@/usecases';
import axios, { CancelTokenSource } from 'axios';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { DataOptions } from 'vuetify';
import DialogoDeCsvClientes from '../clientes/DialogoDeCsvClientes.vue';
import { Display } from '../clientes/TelaDeClientes.vue';


@Component({
	components: {
		ListagemDeCashback,
		DataTableDeCrud,
	},
})
export default class TelaDeCashback extends Vue {
	@Ref() dialogoDeCsvCliente!: DialogoDeCsvClientes

	headers = [
		{ text: 'Nome', value: 'razaoSocialOuNome' },
		{ text: 'CPF/CNPJ', value: 'cnpjOuCpfFormatado' },
		{ text: 'Estado', value: 'endereco.uf' },
	]

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	totalRegistros = -1

	carregando = false
	mostrar = false

	busca = ''

	editando = true

	clientes: Cliente[] = []
	cliente: Cliente | null = null

	findUseCase = new FindClienteUseCase()
	cancelToken: CancelTokenSource | null = null

	created() {
		this.buscar()
	}

	async buscar() {
		if (this.cancelToken) this.cancelToken.cancel()
		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()

			const params = {
				page: this.paginacao.page - 1,
				busca: this.busca || undefined,
				size: this.paginacao.itemsPerPage,
			}

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			const page = await this.findUseCase.findClienteComCashback(params, axiosConfig)
			this.totalRegistros = page.totalElements
			this.clientes = page.content
			this.carregando = false
		} catch (error) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
			this.carregando = false
		}
	}

	async abrirDialogoDeCashback(indice: any) {
		this.cliente = this.clientes[indice]
		this.mostrar = true
		
	}

	get itensFormatados(): Display[] {
		return this.clientes.map(cliente => ({
			...cliente,
			cnpjOuCpfFormatado: cliente.cnpjOuCpf.length <= 11
				? aplicarMascaraParaCpfOculto(cliente.cnpjOuCpf)
				: formatarCnpjOuCpf(cliente.cnpjOuCpf),
		}))
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao = this.buscar

	@Watch('busca')
	onChangeBusca() {
		this.paginacao.page = 1
		this.buscar()
	}
}
